import { render, staticRenderFns } from "./SavedSearchesWidget.vue?vue&type=template&id=5c6cc548&scoped=true&"
import script from "./SavedSearchesWidget.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SavedSearchesWidget.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6cc548",
  null
  
)

export default component.exports